import { USER } from '~/consts'

export default async function ({ store, redirect, app, error, route }) {
  const cookies = app.$cookies;
  let auth = store.state.auth

  if (!auth) {
    // GET USER DATA
    let data = null
    try {
      let res = await app.$axios.post(USER.GET_PROFILE);
      data = res.data
    } catch ({ response }) {
    }

    if (!helpers.isEmpty(data) && data.applicationSystem.code == 9) {
      store.commit('setState', { key: 'maintenance_message', value: data.applicationSystem.message })

      return redirect('/maintenance');
    }

    auth = data.data;
  }

  if (!helpers.isEmpty(auth)) {
    auth['is_admin'] = auth.email == 'edlink.sevima@gmail.com';
    store.commit('setAuth', auth);
  }
}
